import { useState } from "react";
import styles from "./AdminMenuPanel.module.css";
import {
  FaLayerGroup,
  FaAngleDown,
  FaAngleRight,
  FaUsers,
  FaHome,
  FaLink,
  FaVideo,
} from "react-icons/fa";
import useDashboardStore from "../../store/dashboardStore";

const AdminMenuPanel = () => {
  const [openCommunities, setOpenCommunities] = useState(true);
  const [openChannels, setOpenChannels] = useState(true);
  const [openLiveSessions, setOpenLiveSessions] = useState(true);
  const [openHomeSections, setOpenHomeSections] = useState(true);
  const [openContentPages, setOpenContentPages] = useState(true);

  const {
    setIsCreateCommunityScreen,
    setIsEditUs30ContentScreen,
    setIsAllCommunityScreen,
    setIsCreateChannelScreen,
    setIsAllChannelScreen,
    setIsCreateLiveSessionScreen,
    setIsAllLiveSessionScreen,
    setIsAllHomeSectionScreen,
    setIsCreateHomeSectionScreen,
    setIsUsersScreen,
    setEditCommunityId,
    setEditChannelId,
    setEditLiveSession,
    setEditHomeSectionId,
    setIsEditWeeklyLinksContentScreen,
    setIsEditReplaySessionsContentScreen,
    isAllCommunityScreen,
    isCreateCommunityScreen,
    isEditUs30ContentScreen,
    isAllChannelScreen,
    isCreateChannelScreen,
    isAllLiveSessionScreen,
    isCreateLiveSessionScreen,
    isAllHomeSectionScreen,
    isCreateHomeSectionScreen,
    isEditWeeklyLinksContentScreen,
    isEditReplaySessionsContentScreen,
  } = useDashboardStore();

  return (
    <div className={styles.panelWrapper}>
      {/* Communities Menu */}
      <div
        className={styles.menuItem}
        onClick={() => setOpenCommunities(!openCommunities)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Communities</span>
        {openCommunities ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openCommunities && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllCommunityScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllCommunityScreen(true)}
          >
            All Communities
          </div>
          <div
            className={
              isCreateCommunityScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateCommunityScreen(true);
              setEditCommunityId(null);
            }}
          >
            Add Community
          </div>
          <div
            className={
              isEditUs30ContentScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsEditUs30ContentScreen(true)}
          >
            Edit US30 Content
          </div>
        </div>
      )}

      {/* Channels Menu */}
      <div
        className={styles.menuItem}
        onClick={() => setOpenChannels(!openChannels)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Channels</span>
        {openChannels ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openChannels && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllChannelScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllChannelScreen(true)}
          >
            All Channels
          </div>
          <div
            className={
              isCreateChannelScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateChannelScreen(true);
              setEditChannelId(null);
            }}
          >
            Add Channel
          </div>
        </div>
      )}

      {/* Live Sessions Menu */}
      <div
        className={styles.menuItem}
        onClick={() => setOpenLiveSessions(!openLiveSessions)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Live sessions</span>
        {openLiveSessions ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openLiveSessions && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllLiveSessionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllLiveSessionScreen(true)}
          >
            All Sessions
          </div>
          <div
            className={
              isCreateLiveSessionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateLiveSessionScreen(true);
              setEditLiveSession(null);
            }}
          >
            Add Session
          </div>
        </div>
      )}

      {/* Home Sections Menu */}
      <div
        className={styles.menuItem}
        onClick={() => setOpenHomeSections(!openHomeSections)}
      >
        <FaHome className={styles.icon} />
        <span>Home Sections</span>
        {openHomeSections ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openHomeSections && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllHomeSectionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllHomeSectionScreen(true)}
          >
            All Home Sections
          </div>
          <div
            className={
              isCreateHomeSectionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => {
              setIsCreateHomeSectionScreen(true);
              setEditHomeSectionId(null);
            }}
          >
            Add Home Section
          </div>
        </div>
      )}

      {/* NEW: Content Pages Menu */}
      <div
        className={styles.menuItem}
        onClick={() => setOpenContentPages(!openContentPages)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Content Pages</span>
        {openContentPages ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openContentPages && (
        <div className={styles.subMenu}>
          <div
            className={
              isEditWeeklyLinksContentScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsEditWeeklyLinksContentScreen(true)}
          >
            Edit Weekly Links
          </div>
          <div
            className={
              isEditReplaySessionsContentScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsEditReplaySessionsContentScreen(true)}
          >
            Edit Replay Sessions
          </div>
        </div>
      )}

      {/* Users Menu */}
      <div className={styles.menuItem} onClick={() => setIsUsersScreen(true)}>
        <FaUsers className={styles.icon} />
        <span>Users</span>
      </div>
    </div>
  );
};

export default AdminMenuPanel;
